import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { Validator } from '~/types';
import i18n from '~/i18n';

const t = i18n.t.bind(i18n);

const phoneValidation: Validator = (rule, value, callback) => {
  try {
    const phoneNumber = parsePhoneNumberFromString(value);
    if (!phoneNumber?.isPossible) {
      throw new Error(t('impossiblePhone'));
    }
    if (!phoneNumber?.isValid()) {
      throw new Error(t('invalidPhone'));
    }
    callback();
  } catch (err: any) {
    callback(err);
  }
};

const basicValidation: Validator = (rule, value, callback) => {
  if (rule.required && !value) {
    callback(t('required'));
  } else if (value) {
    void phoneValidation(rule, value, callback);
  } else {
    callback();
  }
};

export default basicValidation;
